import { SearchX } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function TopupConfirmationNotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center py-20 text-center animate-fade-up">
      <div className="grid size-14 place-items-center rounded-full border border-muted bg-primary-foreground">
        <SearchX className="size-6 text-secondary-foreground" />
      </div>
      <div className="mt-5 text-xs font-bold uppercase tracking-[0.22em] text-heading">
        Top-up Booking Not Found
      </div>
      <p className="mt-2 max-w-sm text-sm text-secondary-foreground">
        We couldn't find a booking for this payment. The link may be invalid or
        expired.
      </p>
      <Button
        type="button"
        variant="secondary"
        className="w-full cursor-pointer"
        onClick={() => navigate("/")}
      >
        Back to Home
      </Button>
    </div>
  );
}
